function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = ['onRequest', 'autoRequestOnMount'];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, {
  useMemo,
  useRef,
  useCallback,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import StandardizeTable from './model';
var noop = function noop() {};
var RequestTable = /*#__PURE__*/ forwardRef(function (props, ref) {
  var _originTable$paginati,
    _originFilter$initial,
    _ref,
    _originClassification,
    _originClassification2;
  var _props$onRequest = props.onRequest,
    onRequest = _props$onRequest === void 0 ? noop : _props$onRequest,
    autoRequestOnMount = props.autoRequestOnMount,
    others = _objectWithoutProperties(props, _excluded);
  var originFilter = props.filter,
    originClassification = props.classification,
    originTable = props.table,
    originBatchedActions = props.batchedActions;
  var paginationValues = useRef(
    (_originTable$paginati = originTable.pagination) !== null && _originTable$paginati !== void 0
      ? _originTable$paginati
      : {},
  );
  var filterValues = useRef(
    (_originFilter$initial =
      originFilter === null || originFilter === void 0 ? void 0 : originFilter.initialValues) !==
      null && _originFilter$initial !== void 0
      ? _originFilter$initial
      : {},
  );
  var sorterValues = useRef({});
  var classificationId = useRef(
    (_ref =
      (originClassification === null || originClassification === void 0
        ? void 0
        : (_originClassification = originClassification.defaultSelectedKeys) === null ||
          _originClassification === void 0
        ? void 0
        : _originClassification[0]) ||
      (originClassification === null || originClassification === void 0
        ? void 0
        : (_originClassification2 = originClassification.selectedKeys) === null ||
          _originClassification2 === void 0
        ? void 0
        : _originClassification2[0])) !== null && _ref !== void 0
      ? _ref
      : null,
  );
  var instance = useRef(null);
  useImperativeHandle(ref, function () {
    return instance.current;
  });
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    initial = _useState2[0],
    setInitial = _useState2[1];
  useEffect(
    function () {
      var _ref2, _originClassification3, _originClassification4;
      if (originClassification && !classificationId.current) return;
      if (!autoRequestOnMount) return;
      if (!initial) return;
      setInitial(false);
      classificationId.current =
        (_ref2 =
          (originClassification === null || originClassification === void 0
            ? void 0
            : (_originClassification3 = originClassification.defaultSelectedKeys) === null ||
              _originClassification3 === void 0
            ? void 0
            : _originClassification3[0]) ||
          (originClassification === null || originClassification === void 0
            ? void 0
            : (_originClassification4 = originClassification.selectedKeys) === null ||
              _originClassification4 === void 0
            ? void 0
            : _originClassification4[0])) !== null && _ref2 !== void 0
          ? _ref2
          : null;
      onRequest({
        filter: filterValues.current,
        classificationId: classificationId.current,
        pagination: paginationValues.current,
        sorter: sorterValues.current,
      });
    },
    [classificationId, originClassification],
  );
  var triggerOnRequest = useCallback(
    function () {
      onRequest({
        filter: filterValues.current,
        classificationId: classificationId.current,
        pagination: paginationValues.current,
        sorter: sorterValues.current,
      });
    },
    [onRequest],
  );
  var filter = useMemo(
    function () {
      if (!originFilter) return undefined;
      var _onSearch = originFilter.onSearch;
      return _objectSpread(
        _objectSpread({}, originFilter),
        {},
        {
          onSearch: function onSearch() {
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key];
            }
            var formValues = args[0],
              others = args[1];
            var cID = others.classificationId,
              pagination = others.pagination;
            filterValues.current = formValues;
            classificationId.current = cID;
            paginationValues.current = pagination;
            triggerOnRequest();
            _onSearch === null || _onSearch === void 0 ? void 0 : _onSearch.apply(void 0, args);
          },
        },
      );
    },
    [originFilter, triggerOnRequest],
  );
  var batchedActions = useMemo(
    function () {
      if (!originBatchedActions) return undefined;
      return originBatchedActions.map(function (item) {
        return _objectSpread(
          _objectSpread({}, item),
          {},
          {
            onClick: function onClick() {
              var _item$onClick, _item$onClick$call;
              for (
                var _len2 = arguments.length, args = new Array(_len2), _key2 = 0;
                _key2 < _len2;
                _key2++
              ) {
                args[_key2] = arguments[_key2];
              }
              return (_item$onClick = item.onClick) === null || _item$onClick === void 0
                ? void 0
                : (_item$onClick$call = _item$onClick.call.apply(
                    _item$onClick,
                    [item].concat(args),
                  )) === null || _item$onClick$call === void 0
                ? void 0
                : _item$onClick$call.then(function (res) {
                    triggerOnRequest();
                  });
            },
          },
        );
      });
    },
    [originBatchedActions, triggerOnRequest],
  );
  var classification = useMemo(
    function () {
      if (!originClassification) return undefined;
      // 初始化classificationId数据
      if (classificationId.current === null) {
        if (isArrayAndNotEmpty(originClassification.defaultSelectedKeys)) {
          classificationId.current = originClassification.defaultSelectedKeys[0];
        }
        if (isArrayAndNotEmpty(originClassification.selectedKeys)) {
          classificationId.current = originClassification.selectedKeys[0];
        }
      }
      return _objectSpread(
        _objectSpread({}, originClassification),
        {},
        {
          onSelect: function onSelect(selectedKey, params) {
            originClassification.onSelect(selectedKey, params);
            classificationId.current =
              selectedKey !== null && selectedKey !== void 0 ? selectedKey : null;
            paginationValues.current = _objectSpread(
              _objectSpread({}, paginationValues.current),
              {},
              {
                current: 1,
              },
            );
            triggerOnRequest();
          },
          // treeData: originClassification.treeData ?? [],
        },
      );
    },
    [originClassification, triggerOnRequest],
  );
  var table = useMemo(
    function () {
      // if (!originTable) return undefined;
      var originPagination = originTable.pagination,
        originTableOnChange = originTable.onChange,
        _originTable$columns = originTable.columns,
        originColumns = _originTable$columns === void 0 ? [] : _originTable$columns;
      // if (!originPagination) return originTable;
      // const { onChange: originOnChange, onShowSizeChange: originOnShowSizeChange } = originPagination;
      // const pagination = { ...originPagination };
      // pagination.onChange = (current, pageSize) => {
      //   originOnChange?.(current, pageSize);
      //   paginationValues.current = {
      //     ...paginationValues.current,
      //     current,
      //     pageSize,
      //   };
      //   triggerOnRequest();
      // };
      // pagination.onShowSizeChange = (current, pageSize) => {
      //   originOnShowSizeChange?.(current, pageSize);
      //   paginationValues.current = {
      //     ...paginationValues.current,
      //     current,
      //     pageSize,
      //   };
      //   triggerOnRequest();
      // };
      var columns = originColumns.map(function (c) {
        if (c.renderType === 'actions') {
          return _objectSpread(
            _objectSpread({}, c),
            {},
            {
              buttons: c.buttons.map(function (b) {
                return _objectSpread(
                  _objectSpread({}, b),
                  {},
                  {
                    onClick: function onClick(item) {
                      var _b$onClick;
                      (_b$onClick = b.onClick(item)) === null || _b$onClick === void 0
                        ? void 0
                        : _b$onClick.then(function () {
                            triggerOnRequest();
                          });
                    },
                  },
                );
              }),
            },
          );
        }
        return c;
      });
      var onChange = function onChange() {
        for (
          var _len3 = arguments.length, args = new Array(_len3), _key3 = 0;
          _key3 < _len3;
          _key3++
        ) {
          args[_key3] = arguments[_key3];
        }
        originTableOnChange === null || originTableOnChange === void 0
          ? void 0
          : originTableOnChange.apply(void 0, args);
        var pagination = args[0],
          filters = args[1],
          sorter = args[2],
          extra = args[3];
        paginationValues.current = _objectSpread(
          _objectSpread({}, paginationValues.current),
          pagination,
        );
        sorterValues.current = sorter;
        triggerOnRequest();
      };
      return _objectSpread(
        _objectSpread({}, originTable),
        {},
        {
          onChange: onChange,
          columns: columns,
          // pagination,
        },
      );
    },
    [originTable, triggerOnRequest],
  );
  return /*#__PURE__*/ React.createElement(
    StandardizeTable,
    _objectSpread(
      _objectSpread({}, others),
      {},
      {
        batchedActions: batchedActions,
        table: table,
        classification: classification,
        filter: filter,
        ref: instance,
      },
    ),
  );
});
RequestTable.defaultProps = {
  autoRequestOnMount: true,
};
export default /*#__PURE__*/ React.memo(RequestTable);
function isArrayAndNotEmpty(data) {
  if (!Array.isArray(data)) return false;
  if (!data.length) return false;
  return true;
}
